let hash = {};
let query = {};

export const hasher = {
    name: 'hasher',
    store() {
        return {
            hashes: {},
            queries: {},
            init() {
            },
            setHash(key, val) {
                this.hashes[key] = val;
                return val;
            },

            getHash(key) {
                return this.hashes[key] || '';
            },

            setQuery(key, val) {
                this.queries[key] = val;
                return val;
            },

            getQuery(key) {
                return this.queries[key] || '';
            },

            dispatchHash() {
                let hashEv = new Event('hash', { bubbles: true });
                dispatchEvent(hashEv);
            }
        }
    }
}
export default hasher;
